import { NodeTree } from '@craftjs/core';

export type FaqState = {
  buffer: NodeTree[];
};

export const defaultFaqState: FaqState = {
  buffer: [],
};
